import { LogoutOutlined } from "@ant-design/icons";
import { useMutation, useQuery } from "@apollo/react-hooks";
import { Button, Form, Typography } from "antd";
import * as moment from "moment";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { OnboardingLocationCard } from "../../../../Components/Cards/Onboarding/Location";
import { Loader } from "../../../../Components/Loader";
import { OnboardingModal } from "../../../../Components/Modals/OnboardingModal";
import { CustIcon } from "../../../../Components/Svgs";
import {
  INSERT_LOCATION,
  UPDATE_LOCATION_DATA,
  UPDATE_USER_LAST_SCREEN,
  UPSERT_USER_SHIFT,
} from "../../../../Graphql/mutations";
import { GET_LOCATION_DETAILS_BY_OWNER } from "../../../../Graphql/queries";
import { logout } from "../../../../Utils/functions/common";

const { Title } = Typography;

export const LocationManagementPage = () => {
  const history = useHistory();
  const [showIntroModal, setShowIntroModal] = useState(false);
  const [form] = Form.useForm();

  const { data: locationDetails, loading: locationDetailsLoading } = useQuery(
    GET_LOCATION_DETAILS_BY_OWNER,
    {
      variables: {
        user_id: localStorage.getItem("user_id"),
      },
      fetchPolicy: "cache-and-network",
      context: {
        headers: {
          subscription: 1,
        },
      },
    }
  );

  const [UPDATE_USER_LAST_SCREEN_MUTATION] = useMutation(
    UPDATE_USER_LAST_SCREEN,
    {
      context: {
        headers: {
          subscription: 1,
        },
      },
    }
  );

  const [INSERT_LOCATIONS_MUTATION, { loading: insertLocationLoading }] =
    useMutation(INSERT_LOCATION, {
      context: {
        headers: {
          subscription: 1,
        },
      },
    });

  const [UPDATE_LOCATION_MUTATION, { loading: updateLocationLoading }] =
    useMutation(UPDATE_LOCATION_DATA, {
      context: {
        headers: {
          subscription: 1,
        },
      },
    });

  const [UPSERT_USER_SHIFT_MUTATION, { loading: updateUserShiftLoading }] =
    useMutation(UPSERT_USER_SHIFT, {
      context: {
        headers: {
          subscription: 1,
        },
      },
    });

  useEffect(() => {
    if (
      locationDetails &&
      locationDetails?.userDetails.last_screen === "/on-boarding/payment-plan"
    ) {
      setShowIntroModal(true);
      UPDATE_USER_LAST_SCREEN_MUTATION({
        variables: {
          user_id: localStorage.getItem("user_id"),
          last_screen: history.location.pathname,
        },
        context: {
          headers: {
            subscription: 1,
          },
        },
      });
    }
    if (
      locationDetails &&
      locationDetails?.locationsByOwner.locations.length > 0
    ) {
      let locationList = locationDetails.locationsByOwner.locations;
      locationList.forEach((singleLocation, index) => {
        form.setFieldsValue({
          [`name${index}`]: singleLocation.locationDetails.location_name,
          [`address${index}`]: singleLocation.locationDetails.street_address,
          [`zipcode${index}`]: singleLocation.locationDetails.zipcode,
          [`city${index}`]: singleLocation.locationDetails.city,
          [`state${index}`]: singleLocation.locationDetails.state,
          [`country${index}`]: singleLocation.locationDetails.country,
          [`total_employee${index}`]:
            singleLocation.locationDetails.total_employees,
          [`location_id${index}`]: singleLocation.locationDetails.location_id,
          [`timezone_id${index}`]: singleLocation.locationDetails.timezone_id,
          [`timezone_name${index}`]:
            singleLocation.locationDetails.timezone_name,
        });
        if (singleLocation.locationDetails.workingHours.length > 0) {
          let endTime =
            singleLocation.locationDetails.workingHours[0]?.closing_time.split(
              ":"
            );
          let momentEndTime = moment()
            .set("hours", endTime[0])
            .set("minutes", endTime[1])
            .set("seconds", endTime[2]);
          let startTime =
            singleLocation.locationDetails.workingHours[0]?.opening_time.split(
              ":"
            );
          let momentStartTime = moment()
            .set("hours", startTime[0])
            .set("minutes", startTime[1])
            .set("seconds", startTime[2]);
          form.setFieldsValue({
            [`end_time${index}`]: momentEndTime,
            [`start_time${index}`]: momentStartTime,
          });
        }
      });
    }
  }, [locationDetails]);

  const onFinish = async (values) => {
    let insertLocations = [];
    let updateLocations = [];
    let ownerShiftTime = [];
    for (
      let index = 0;
      index < locationDetails?.businesses[0].location_count;
      index++
    ) {
      if (index == locationDetails?.businesses[0].location_count - 1) {
        //To insert last location shift timing as a owner shift timing
        [...Array.from(Array(7).keys())].forEach((i) => {
          ownerShiftTime.push({
            user_id: localStorage.getItem("user_id"),
            working_day: moment().set("day", i).format("dddd"),
            start_time: values[`start_time${index}`].format("HH:mm"),
            end_time: values[`end_time${index}`].format("HH:mm"),
          });
        });
      }

      //Set Same time for all days - Will change once we handle working days for business
      if (!values[`location_id${index}`]) {
        let locationTimings = [];
        [...Array.from(Array(7).keys())].forEach((i) => {
          locationTimings.push({
            working_day: moment().set("day", i).format("dddd"),
            opening_time: values[`start_time${index}`].format("HH:mm"),
            closing_time: values[`end_time${index}`].format("HH:mm"),
          });
        });
        insertLocations.push({
          user_id: localStorage.getItem("user_id"),
          business_id: locationDetails.businesses[0].business_id,
          job_role_id: locationDetails.roleDetails[0].role_id,
          locationDetails: {
            data: {
              location_name: values[`name${index}`],
              street_address: values[`address${index}`],
              zipcode: values[`zipcode${index}`],
              city: values[`city${index}`],
              state: values[`state${index}`],
              country: values[`country${index}`],
              total_employees: parseInt(values[`total_employee${index}`]),
              timezone_id: values[`timezone_id${index}`],
              timezone_name: values[`timezone_name${index}`],
              location_timings: {
                data: locationTimings,
              },
            },
          },
        });
      } else {
        updateLocations.push({
          location_id: values[`location_id${index}`],
          location_update_fields: {
            location_name: values[`name${index}`],
            street_address: values[`address${index}`],
            zipcode: values[`zipcode${index}`],
            city: values[`city${index}`],
            state: values[`state${index}`],
            country: values[`country${index}`],
            total_employees: parseInt(values[`total_employee${index}`]),
            timezone_id: values[`timezone_id${index}`],
            timezone_name: values[`timezone_name${index}`],
          },
          opening_time: values[`start_time${index}`].format("HH:mm"),
          closing_time: values[`end_time${index}`].format("HH:mm"),
        });
      }
    }
    try {
      let insertSuccess = await insertNewLocations(insertLocations);
      let updateSuccess = await updateExistingLocations(updateLocations);
      let upsertOwnerShiftTimingSuccess = await upsertOwnerShiftTiming(
        ownerShiftTime
      );
      if (insertSuccess && updateSuccess && upsertOwnerShiftTimingSuccess) {
        history.push("/on-boarding/area-manager");
      }
    } catch (error) {}
  };

  const insertNewLocations = async (insertLocations) => {
    if (insertLocations.length === 0) {
      return true;
    }
    try {
      const insertResponse = await INSERT_LOCATIONS_MUTATION({
        variables: {
          objects: insertLocations,
        },
      });
      if (insertResponse.errors) {
        return false;
      } else {
        return true;
      }
    } catch (error) {}
  };

  const updateExistingLocations = async (updateLocations) => {
    if (updateLocations.length === 0) {
      return true;
    }
    let updateSuccess = await Promise.all(
      updateLocations.map(async (singleUpdateLocation, index) => {
        try {
          const updateResponse = await UPDATE_LOCATION_MUTATION({
            variables: singleUpdateLocation,
          });
          if (updateResponse.errors) {
            return false;
          } else {
            return true;
          }
        } catch (error) {}
      })
    );
    if (updateSuccess.includes(false)) {
      return false;
    } else {
      return true;
    }
  };

  const upsertOwnerShiftTiming = async (ownerShiftTime) => {
    if (ownerShiftTime.length === 0) {
      return true;
    }
    try {
      const upsertResponse = await UPSERT_USER_SHIFT_MUTATION({
        variables: {
          objects: ownerShiftTime,
        },
      });
      if (upsertResponse.errors) {
        return false;
      } else {
        return true;
      }
    } catch (error) {
      return false;
    }
  };

  return (
    <div className="onBoardingRight">
      {locationDetailsLoading ? (
        <Loader />
      ) : (
        <div className="location">
          <div className="">
            <div className="d-flex justify-content-between align-items-start">
              <Title level={2}>Setup Your Locations</Title>
              <div
                className="d-flex align-items-center cursorPointer txtdark"
                onClick={() => logout()}
              >
                <CustIcon type="logout-alt" className="fz-18" />
                <span className="pl-2">Logout</span>
              </div>
            </div>
            <p className="subTitle">
              Enter your location details and setup each store.
            </p>
          </div>
          <Form form={form} name="basic" onFinish={onFinish}>
            {[...Array(locationDetails?.businesses[0].location_count)].map(
              (_value, index) => (
                <OnboardingLocationCard form={form} key={index} id={index} />
              )
            )}
            <Form.Item className="buttonSec">
              <Button
                loading={
                  insertLocationLoading ||
                  updateLocationLoading ||
                  updateUserShiftLoading
                }
                type="primary"
                shape="round"
                size="large"
                htmlType="submit"
              >
                {insertLocationLoading ||
                updateLocationLoading ||
                updateUserShiftLoading
                  ? "Submitting"
                  : "Submit"}
              </Button>
            </Form.Item>
          </Form>
        </div>
      )}
      {showIntroModal && (
        <OnboardingModal closeModal={() => setShowIntroModal(false)} />
      )}
    </div>
  );
};
